module.exports = __webpack_public_path__ + "img/thank-login-logo.acfccece.png";